import { Grid, Link, Typography } from "@mui/material";
import { styled, useTheme } from "@mui/system";
import PlusIcon from "../../assets/icons/PlusIcon";
import { useDispatch, useSelector } from "react-redux";
import { appSetModal } from "../../store/actions/appAction";
import { useNavigate } from "react-router-dom";
import shortid from "shortid";
import widgets from "assets/js/widgetItems";
import { itemsSideBarImage } from "assets/js/itemsSidebar";
import { useEffect, useState } from "react";
import reportItems from "../../assets/js/widgetItems";

const GridBox = styled("div")(({ theme }) => ({
    display: "grid",
    width: "100%",
    gridTemplateColumns: " repeat(auto-fill, 6.25%)",
    gridGap: "2%",
    justifyContent: "space-between",
    [theme.breakpoints.down("lg")]: {
        gridTemplateColumns: "repeat(auto-fill, 10%)",
        gridGap: "8px",
    },
    [theme.breakpoints.down("md")]: {
        gridTemplateColumns: "repeat(auto-fill, 17%)",
        gridGap: "4%",
    },
    [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "repeat(auto-fill, 17%)",
        gridGap: "4%",
    },
}));
const ItemContainer = styled("div")({
    display: "flex",
    width: "100%",
    marginBottom: "10px",
    justifyContent: "right",
});

const ItemButton = styled(Link)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    backgroundColor: "white !important",
    borderRadius: theme?.shape?.borderRadius,
    // width: '100px',
    // height: '100px',
    width: "85px",
    height: "85px",
    justifyContent: "space-evenly",
    alignItems: "center",
    textDecoration: "none",
}));
const SubItemContainer = styled("div")(({ theme }) => ({
    flex: 1,
    display: "flex",
    alignItems: "center",
}));

const backgroundImage =
    "data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23AEAEAEFF' strokeWidth='4' stroke-dasharray='10' stroke-dashoffset='42' stroke-linecap='square'/%3e%3c/svg%3e";

const AddAccountButton = styled(ItemButton)(({ theme }) => ({
    backgroundImage: `url("${backgroundImage}")`,
    backgroundSize: "100% 100%",
    backgroundColor: "unset",
}));
const InnerSquer = styled("div")(({ theme }) => ({
    height: "80%",
    width: "80%",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: theme.shape.borderRadius,
    boxShadow: "0px 0px 10px 0px #e6e6e6",
}));
const DashboardUpperContainer = styled(Grid)(({ theme }) => ({
    [theme.breakpoints.down("md")]: {
        display: "none",
    },
}));

const DashboardUpper = () => {
    const {
        palette: { text },
    } = useTheme();
    const dispatch = useDispatch();

    const checkQuickAccess = (data: any) => {
        try {
            if (typeof quickAccess === "string") {
                return JSON.parse(data);
            } else {
                return data;
            }
        } catch (error) {
            return [];
        }
    };

    //@ts-ignore
    let quickAccess = useSelector((state) => state.appReducer.quickAccess as any[]) ?? [];
    let [quickAccessItems, setQuickAccessItems] = useState([])

    useEffect(() => {
        setQuickAccessItems(checkQuickAccess(quickAccess))
    }, [quickAccess])

    const navigate = useNavigate();

    return (
        <div>
            <Typography sx={{ marginBottom: "20px" }} fontWeight="bold" color={text.primary}>
                دسترسی سریع
            </Typography>
            <GridBox>
                {quickAccessItems?.map((item: { url: string, shortName: string }) => (
                    <ItemContainer key={shortid.generate()}>
                        <ItemButton
                            href={item.url}
                            // @ts-ignore
                            onClick={(e) => {
                                navigate(item.url);
                                e.preventDefault();
                            }}
                        >
                            <SubItemContainer>
                                {/* @ts-ignore */}
                                <img src={itemsSideBarImage[item.img] || undefined} />
                            </SubItemContainer>
                            <SubItemContainer>
                                <Typography color="#747575" style={{ fontSize: "11px", fontWeight: "bold" }}>
                                    {item.shortName}
                                </Typography>
                            </SubItemContainer>
                        </ItemButton>
                    </ItemContainer>
                ))}

                <ItemContainer>
                    <AddAccountButton
                        onClick={() => {
                            dispatch(
                                appSetModal(
                                    {
                                        component: "add-account",
                                        title: "دسترسی سریع",
                                        closeButton: true,
                                    },
                                    true
                                )
                            );
                        }}
                    >
                        <InnerSquer>
                            <PlusIcon />
                        </InnerSquer>
                    </AddAccountButton>
                </ItemContainer>
            </GridBox>
        </div>
    );
};

const DashboardComponent = () => {
    //@ts-ignore
    const { widgets: businessWidgets } = useSelector((state) => state).appReducer as {
        widgets: Partial<typeof reportItems>
    };

    return (
        <Grid container spacing={4}>
            <DashboardUpperContainer item lg={12} xl={12} xs={12}>
                <DashboardUpper />
            </DashboardUpperContainer>
            {businessWidgets.filter(w => w !== null).map((widget, index) => {
                // @ts-ignore
                widget = widgets.find(w => w.title === widget.title)
                if (!widget) return <></>

                let { Component, col } = widget;
                return (
                    <Grid key={index} item {...col}>
                        <Component title={widget.title} />
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default DashboardComponent;
